import { render, staticRenderFns } from "./DetailTableDialog.vue?vue&type=template&id=7f8006d1&"
import script from "./DetailTableDialog.vue?vue&type=script&lang=js&"
export * from "./DetailTableDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports